<template>
  <section>
    <PageTitle title="Live Statuses" v-if="!hidePageTitle"
               v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/live_status_of_branches',title:'Live Statuses'}]"
    />
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox-title">
            <h5 class="pull-left">
              Live Status of Vendors
            </h5>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PageTitle from "../components/layout_components/PageTitle";

export default {
  name: "LiveStatusofBranches",
  components: {
    PageTitle
  },
  props: {
    hidePageTitle: {
      type: Boolean,
      default: false,
    }
  },
}
</script>

<style scoped>

</style>